/* NEXperts – Basis-Interaktionen */
(function () {
  "use strict";

  // Mobile-Navigation (Drawer): oeffnen/schliessen, Scroll-Lock, Schliessen per
  // Backdrop, Link-Klick und Escape.
  function setNav(open) {
    var nav = document.getElementById("SiteNav");
    if (!nav) return;
    var toggle = document.querySelector("[data-nav-toggle]");
    nav.setAttribute("data-open", String(open));
    if (toggle) toggle.setAttribute("aria-expanded", String(open));
    document.body.classList.toggle("nav-open", open);
  }

  // Drawer-Breite ODER Geraet ohne Hover (Tablet im Querformat faellt sonst durchs Raster:
  // Desktop-Layout, aber die Hover-Dropdowns sind mit dem Finger nicht erreichbar).
  var touchNav = window.matchMedia("(max-width: 991px), (hover: none)");

  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-nav-toggle]");
    if (toggle) {
      var nav = document.getElementById("SiteNav");
      if (!nav) return;
      setNav(nav.getAttribute("data-open") !== "true");
      return;
    }
    if (e.target.closest("[data-nav-close]")) { setNav(false); return; }

    // Zweite Ebene: Auf Touch-Geraeten gibt es kein Hover, im Drawer erst recht nicht.
    // Ein Tipp auf den Pfeil klappt immer auf/zu; ein Tipp auf den Menuepunkt selbst
    // klappt beim ersten Mal auf und folgt beim zweiten Mal dem Link.
    var parent = e.target.closest("#SiteNav [data-dd-toggle]");
    if (parent && touchNav.matches) {
      var item = parent.closest(".site-nav__item");
      var onCaret = !!e.target.closest(".site-nav__caret");
      var isOpen = item.classList.contains("is-open");
      if (onCaret || !isOpen) {
        e.preventDefault();
        var others = document.querySelectorAll("#SiteNav .site-nav__item.is-open");
        for (var i = 0; i < others.length; i++) {
          if (others[i] === item) continue;
          others[i].classList.remove("is-open");
          var link = others[i].querySelector("[data-dd-toggle]");
          if (link) link.setAttribute("aria-expanded", "false");
        }
        item.classList.toggle("is-open", !isOpen);
        parent.setAttribute("aria-expanded", String(!isOpen));
        return;
      }
    }

    // Klick auf einen Menuelink schliesst den Drawer (auch bei Anker-Links auf
    // der gleichen Seite, wo kein Seitenwechsel folgt)
    if (e.target.closest("#SiteNav a")) { setNav(false); }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var nav = document.getElementById("SiteNav");
    if (nav && nav.getAttribute("data-open") === "true") setNav(false);
  });

  // Beim Wechsel auf Desktop-Breite den Drawer-Zustand zuruecksetzen,
  // sonst bleibt der Scroll-Lock haengen.
  var mq = window.matchMedia("(min-width: 992px)");
  var onMq = function (ev) {
    if (!ev.matches) return;
    setNav(false);
    var open = document.querySelectorAll("#SiteNav .site-nav__item.is-open");
    for (var i = 0; i < open.length; i++) {
      open[i].classList.remove("is-open");
      var link = open[i].querySelector("[data-dd-toggle]");
      if (link) link.setAttribute("aria-expanded", "false");
    }
  };
  if (mq.addEventListener) mq.addEventListener("change", onMq);
  else if (mq.addListener) mq.addListener(onMq);

  // Header ein-/ausblenden je nach Scroll-Richtung (wie alte Seite):
  // runterscrollen -> ausblenden, hochscrollen -> wieder einblenden.
  var header = document.querySelector(".site-header");
  if (header) {
    var lastY = window.pageYOffset || 0;
    var ticking = false;
    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var nav = document.getElementById("SiteNav");
      if (nav && nav.getAttribute("data-open") === "true") { ticking = false; return; }
      if (y < 120) { header.classList.remove("is-hidden"); lastY = y; ticking = false; return; }
      if (Math.abs(y - lastY) > 8) {
        if (y > lastY) { header.classList.add("is-hidden"); }
        else { header.classList.remove("is-hidden"); }
        lastY = y;
      }
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
  }

  // Splide-Slider automatisch initialisieren: NUR <div class="splide" data-splide='{...}'>.
  // Sektionen mit eigenem Inline-Init (wb-details, experts-slider) haben KEIN data-splide
  // und werden hier bewusst übersprungen – sonst doppelter mount() → doppelte Clones/Pagination.
  // Retry, bis Splide geladen ist (ein CMP kann die Ausführung von splide.min.js verzögern).
  var splideTries = 0;
  function mountAutoSplide() {
    if (typeof Splide === "undefined") { if (++splideTries < 60) setTimeout(mountAutoSplide, 60); return; }
    document.querySelectorAll(".splide[data-splide]").forEach(function (el) {
      if (el.classList.contains("is-initialized")) return;
      try { new Splide(el).mount(); } catch (err) { /* noop */ }
    });
  }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", mountAutoSplide); }
  else { mountAutoSplide(); }
})();
